import superagent from 'superagent';
import qs from 'qs';
import EventBus from './EventBus.js';

class API {
    constructor() {
    //    this.api_root = 'https://demo4246429.mockable.io/api/v1';
        this.api_root = '/api/v1';
        this.api_key = '';
        this.account = null;

        this.callQueue = [];
    };

    setCredentials(apiKey) {
        this.api_key = apiKey;
    };

    authenticate(identifier, secret, mode, callback) {
        this.call('post', '/authenticate', [], {
            identifier: identifier,
            secret: secret,
            mode: mode
        }, (data) => {
            if (data.success) {
                this.setCredentials(data.api_key);
                callback(true);

                this.account = data.account;

                this._processCallQueue();

                EventBus.emit('auth.success', {
                    api_key: data.api_key,
                    account: data.account
                });
            } else {
                EventBus.emit('auth.failed', {
                    message: data.error
                });
            }
        }, () => {
            callback(false);
        }, true);
    };
    
    async getQueueInfo(items, format) {
        let arr = [];
        for (let item of items) {
            if (item.id == undefined) {
                continue;
            }
            let sourceData = await superagent.get('/api/v1/listen/' + item.id + '?type=preload').set('X-Pristine-Player-API-Key', this.api_key);
            let trackData = await superagent.get('/api/v1/tracks/' + item.id + '?with[]=album').set('X-Pristine-Player-API-Key', this.api_key);
            
            let src = null;
            if (sourceData.body.hasOwnProperty('sources')) {
                if (sourceData.body.sources[format]) {
                    src = sourceData.body.sources[format];
                } else {
                    src = sourceData.body.sources['mp3'];
                } 
                
                arr.push({
                    src: src,
                    track: trackData.body.hasOwnProperty('track') ? trackData.body.track: {},
                });
            }
        }
        return arr;
    };

    createApiUrl(method, path, params, data) {
        for (let key in params) {
            path = path.replace('{{'+key+'}}', params[key]);
        }
        return this.api_root + path;
    };

    call(method, path, params, data, success, failure, force) {
        if (force || this.api_key) {
            this._call(method, path, params, data, success, failure);
        } else {
            this.callQueue.push({
                method,
                path,
                params,
                data,
                success,
                failure
            });
        }
    };

    _call(method, path, params, data, success, failure) {
        let url = this.createApiUrl(method, path, params, data);

        var request = superagent[method](url);
        if (method == 'get') {
            request = request.query(qs.stringify(data));
        } else {
            request = request.send(data);
        }

        if (this.api_key) {
            request = request.set('X-Pristine-Player-API-Key', this.api_key);
        }

        request.type('json')
               .then(function(res) {
                   console.log(res);
                   var freePlays = res.header['x-pristine-player-free-plays'];
                   EventBus.emit('account.freePlaysChanged', {
                       freePlays: Number(freePlays)
                   });

                   success(res.body, res);
               }, failure);
    }

    _processCallQueue() {
        for (let data of this.callQueue) {
            this._call(data.method, data.path, data.params, data.data, data.success, data.failure);
        }
    }

    get(path, params, data, success, failure) { this.call('get', path, params, data, success, failure); }
    post(path, params, data, success, failure) { this.call('post', path, params, data, success, failure); }
}

export let api = new API();



// WEBPACK FOOTER //
// ./src/API.js